import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ align: [] }],
    ['blockquote', 'link'],
    ['clean'],
  ],
};

const formats = [
  'header', 'bold', 'italic', 'underline', 'strike',
  'list', 'align', 'blockquote', 'link',
];

/**
 * Reusable rich-text (WYSIWYG) editor. Stores HTML.
 * Backward compatible: old plain-text content is shown as-is in the editor.
 */
export default function RichTextEditor({ value, onChange, placeholder, testId }) {
  return (
    <div className="rich-editor bg-background rounded-lg border border-input" data-testid={testId}>
      <ReactQuill
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder || 'İçeriği buraya yazın...'}
      />
    </div>
  );
}
